<script>
import debounce from 'lodash/debounce';
import animation from '../components/animate.vue';
import magnitize from '../components/magnetic-links';

export default {
    components: {
        animation
    },

    data() {
        return {
            stickyTrigger: 320,
            sticky: false
        };
    },

    created() {
        this.debounceScroll = debounce(this.stickyUpdate, 100);
        window.addEventListener('scroll', this.debounceScroll);
    },

    destroyed() {
        window.removeEventListener('scroll', this.debounceScroll);
    },

    mounted() {
        this.$root.$on('ready', this.animateIn);
        this.stickyUpdate();
    },

    methods: {
        animateIn() {
            const tl = greensock.timeline();

            tl.to(this.$refs.logo, {
                opacity: 1,
                duration: 0.32,
                delay: 0.56,
                ease: 'power2.out'
            })
                .fromTo(
                    this.$refs.riverwatch,
                    {
                        opacity: 0,
                        scale: 1.4
                    },
                    {
                        opacity: 1,
                        scale: 1,
                        duration: 1.5,
                        ease: 'quad.inOut'
                    },
                    '<0.32'
                )
                .to(
                    this.$refs.actionItems,
                    {
                        opacity: 1,
                        duration: 0.32,
                        ease: 'quad.inOut'
                    },
                    '<0.64'
                );
        },

        stickyUpdate() {
            if (window.scrollY > this.stickyTrigger) {
                if (!this.sticky) {
                    this.sticky = true;
                    this.$refs.headerBackground.classList.remove('opacity-0', '-translate-y-full');
                    this.$refs.headerBackground.classList.add('opacity-100', 'translate-y-0');
                }
            } else {
                if (this.sticky) {
                    this.sticky = false;
                    this.$refs.headerBackground.classList.remove('opacity-100', 'translate-y-0');
                    this.$refs.headerBackground.classList.add('opacity-0', '-translate-y-full');
                }
            }
        },

        magnetizeMe(ev, element, force) {
            magnitize.start(ev, this.$el, element, force);
        },

        deMagnetize(element) {
            magnitize.stop(element);
        }
    }
};
</script>
